function EventSequenceModel(BaseModel) {
    'ngInject';

    class EventSequence extends BaseModel {
        name() {
            return this._data.name;
        }
    }

    return EventSequence;
}

/***
 * @ngdoc service
 * @name BB:EventSequence
 *
 * @description
 * Representation of an EventSequence Object
 *
 * @property {integer} total_entries The total of entries in  event groupst
 * @property {array} event_chains An array with items of the event
 */
angular
    .module('BB')
    .service('EventSequenceModel', EventSequenceModel);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/event_sequence_model.service.js